/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});

// if use readmore-feature in site (multiple paragraphs, show only 3 and if you click button show all paragraphs and remove button)
if (document.getElementsByClassName('readmore-feature').length) {
  const readmores = document.getElementsByClassName('readmore-feature');
  for (var i = 0; i < readmores.length; i++) {

    if (i == 2) {
      const div = document.createElement('div');
      const btn = document.createElement('button');
      let buttonText = 'Lue lisää...';

      if(document.getElementsByTagName('html')[0].getAttribute('lang') == 'en-US') {
          buttonText = 'Read more...';
      }

      btn.appendChild(
        document.createTextNode(buttonText)
      );
      btn.setAttribute('class', 'c-button c-button--type-outline readmore-feature__button');
      div.appendChild(btn);

      div.setAttribute('class', 'wp-block-acf-button buttons buttons--align-auto buttons--layout-horizontal is-last-inner-block readmore-feature__container');

      readmores[i].parentNode.insertBefore(div, readmores[i]);
    }

    if (i >= 2) {
      readmores[i].style.display = "none";
    }
  }

  if (document.getElementsByClassName('readmore-feature__container').length) {
    document.getElementsByClassName('readmore-feature__button')[0].addEventListener('click', (el) => {
      const readmores = document.getElementsByClassName('readmore-feature');
      for (var i = 0; i < readmores.length; i++) {
        readmores[i].style.display = "";
      }
      el.target.parentNode.remove();
    });
  }
}


// calculate same height to every element
function sameHeight(query, styleType = 'min-height') {
  if (!document.querySelectorAll(query).length) {
    return;
  }

  const els = document.querySelectorAll(query);
  let height = 0;

  // find most height element
  for (var i = 0; i < els.length; i++) {
    let el = els[i];
    let el_height = el.offsetHeight;

    if (height < el_height) {
      height = el_height;
    }
  }

  for (var i = 0; i < els.length; i++) {
    let el = els[i];
    el.style[styleType] = height + 'px';
  }
}
